import { ListItemText } from '@mui/material';
import { ListItemTextProps } from '@mui/material/ListItemText/ListItemText';

import styles from './styles.module.scss';

export const ListItemTextStyled = (props: ListItemTextProps) => {
  return (
    <ListItemText
      {...props}
      classes={{
        root: styles.root,
      }}
    />
  );
};
